import React from "react"
import CategoryModel from "sdk/CategoryModel"
import shop from "shop/shop"


const hideFollowingIds = {
    "008000000": true, // Beard Head
    "012000000": true,// , Gamago
    "011000000": true,// , Hikali
    "010000000": true,// , Hoobbe
    "026000000": true,// , Nanoku
    "015000000": true,// , Seishin
    "009000000": true,// , Slam
    "027000000": true,// , The Source
    "020000000": true,// , Tobar
    "025000000": true,// Treat Factory
    "035000000": true,// Chasing Threads
    "028000000": true// iThinking
  }

export default class CategoryModelMags extends CategoryModel {
  isHidden = false
  
  
  constructor( data ) {
    super( data )
    this.update()
  }
  
  update() {
    //console.log("hideFollowingIds", Object.keys(hideFollowingIds).length)
    for(let i = 0; i < Object.keys(hideFollowingIds).length; i++){
    //console.log("this.map_id ", this.map_id, "hideFollowingIds[ i] ", Object.keys(hideFollowingIds)[i])
    if ( Object.keys(hideFollowingIds)[i] == this.map_id ) {
        this.isHidden = true
        }
    }
    if ( this.title === "All Around" ) {
        this.title = "All around the world"
      }
    
      this.description = this.desc.des
  }
  
}



// WEBPACK FOOTER //
// ./src/theme/mags/shop/CategoryModel.js